import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 自适应
import "../src/assets/style/reset.styl";
//UI
import Vant from "vant";
import VueWechatTitle from 'vue-wechat-title'
import "vant/lib/index.css";
import "../src/assets/style/index.css";
import "../src/assets/style/reset.css";
import "../src/assets/style/common.css";
// 手写板
import VueSignature from "vue-signature-pad";
Vue.use(Vant);
Vue.use(VueSignature);
Vue.use(VueWechatTitle)
// 公用方法
import {getByType} from '@/api/common/index'
Vue.prototype.$getByType = getByType


Vue.config.productionTip = false;


Vue.config.ignoredElements = [
  'wx-open-launch-weapp'
];

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
